import { func, string } from 'prop-types';
import React from 'react';

import classNames from 'classnames/bind';

import styles from './ProductTitle.css';

const cx = classNames.bind(styles);

const ProductTitle = ({ onProductClick, prefix, productUrl, title }) => {
    const cardTitleClasses = [
        'font-open-sans-semibold',
        'overflow-hidden',
        'text-gray-600 text-small',
        cx('title'),
    ].join(' ');

    const Title = () => {
        const titlePrefix = prefix ? <span className="text-brand">{prefix} </span> : null;

        return productUrl ? (
            <a
                className={cardTitleClasses}
                data-automation-id="product-title"
                href={productUrl}
                onClick={(event) => {
                    onProductClick(event, 'title');
                }}
                title={title}
            >
                {titlePrefix}
                {title}
            </a>
        ) : (
            <div className={cardTitleClasses} data-automation-id="product-title">
                {titlePrefix}
                {title}
            </div>
        );
    };

    return title ? <Title /> : null;
};

ProductTitle.defaultProps = {
    onProductClick: () => {},
    prefix: '',
    productUrl: '',
    title: '',
};

ProductTitle.propTypes = {
    onProductClick: func,
    prefix: string,
    productUrl: string,
    title: string,
};

export default ProductTitle;
